import moment from 'moment';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

import { useStationDetailStore } from '~/store/station-details.store';

import ChartLel from '~/components/chart-lel/chart-lel.vue';
import ChartTemperatureHumidity from '~/components/chart-temperature-humidity/chart-temperature-humidity.vue';
import ComponentBase from '~/components/component-base';

import { AvoltaAlarmEnum } from '~/configs/alarms/avolta-alarm.model';
import { dangerColor, greenColor, warningColor } from '~/variables';
import ChartPpm from '~/components/chart-ppm/chart-ppm.vue';

export default defineComponent({

    extends: ComponentBase,

    components: {
        ChartTemperatureHumidity,
        ChartLel,
        ChartPpm,
    },

    data() {
        return {
            AvoltaAlarmEnum,
            greenColor,
            dangerColor,
            warningColor,

            moment,
        }
    },

    computed: {
        ...mapState(useStationDetailStore, ['station', 'measures', 'since', 'before']),

        inPPM(): boolean {
            return this.isAvolta50(this.station);
        }
    }
});